







































import EmailForm from '@/components/email/EmailForm.vue';
import APIUtils from '@/utils/APIUtils';
import EmailUtils, { Email } from '@/utils/EmailUtils';
import Vue from 'vue';

export default Vue.extend({
  components: { EmailForm },

  data(): {
    state: {
      value?: Partial<Email>;
      errors: undefined;
      isValid: boolean;
      isSubmit: boolean;
      isDelete: boolean;
    };
  } {
    return {
      state: {
        value: undefined,
        errors: undefined,
        isValid: false,
        isSubmit: false,
        isDelete: false,
      },
    };
  },

  async mounted() {
    try {
      this.state.value = await EmailUtils.api.get(this.$route.params?.key);
      (this.$refs.form as any).resetValidation();
    } catch (error) {
      console.error(error);
    }
  },

  methods: {
    async handleSubmit() {
      try {
        this.state.isSubmit = true;
        this.state.errors = undefined;

        if (this.state.value) {
          (this.$refs.form as any).validate();
          this.state.value = EmailUtils.generateDefault(
            await EmailUtils.api.update(this.state.value)
          );
          (this.$refs.form as any).resetValidation();
          this.$toast.push({
            text: this.$t('success.edit', [this.$tc('email.label')]),
            type: 'success',
          });
        }
      } catch (error) {
        this.state.errors = APIUtils.error(error);
        this.$toast.push({
          text: this.$t('error.edit', [this.$tc('email.label')]),
          type: 'error',
        });
      } finally {
        this.state.isSubmit = false;
      }
    },

    async handleDelete() {
      try {
        this.state.isDelete = true;
        this.state.errors = undefined;

        if (this.state.value?.key) {
          await EmailUtils.api.remove(this.state.value.key);
          this.$router.replace({ name: 'email-list' });
          this.$toast.push({
            text: this.$t('success.delete', [this.$tc('email.label')]),
            type: 'success',
          });
        }
      } catch (error) {
        this.state.errors = APIUtils.error(error);
        this.$toast.push({
          text: this.$t('error.delete', [this.$tc('email.label')]),
          type: 'error',
        });
      } finally {
        this.state.isDelete = false;
      }
    },
  },
});
